
export const token = state => state.token

export const loginGo = state => state.loginGo

export const accountData = state => state.accountData
